<template>
  <div class="contracts">
    <!-- switch type search -->
    <h1 class="py-0 text-left mb-5">Contratos area {{ this.info.nombre }}</h1>
    <v-container>

        
      <v-row>
        <v-switch
          v-model="showFilters"
          label="Mostrar filtros"
          class="mt-0 mb-3"
          color="secondary"
          hide-details
        ></v-switch>
        <v-spacer></v-spacer>
        <v-btn class="mx-2" fab right color="secondary" small @click="reload">
          <v-icon> mdi-reload </v-icon>
        </v-btn>
        
               <v-btn class="mx-2" fab right color="success" small @click="generateCsv">
          <v-icon> mdi-file-excel </v-icon>
        </v-btn>
        
      </v-row>
    </v-container>

    <!-- Filters text search -->
    <v-card class="mb-2" v-if="showFilters">
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="6" class="py-0">
            <v-text-field
              label="Filtre por # de contrato, cedula o nombre del colaborador"
              outlined
              hide-details
              dense
              append-icon="mdi-magnify"
              v-model="searchInput"
              clearable
              clear-icon="mdi-close-circle"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="2" class="py-0">
            <v-btn block color="secondary" @click="searchText"> Buscar </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Filters date and options search -->
    <v-card class="mb-2" v-if="showFilters">
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <VueCtkDateTimePicker
              color="DodgerBlue"
              v-model="datePiker.model"
              :label="datePiker.label"
              :range="true"
              :custom-shortcuts="datePiker.shortcut"
              :format="datePiker.format"
              :formatted="datePiker.formatted"
              inputSize="sm"
            />
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-select
              outlined
              :items="this.$store.state.status.contractStatus"
              label="Seleccione Estado"
              no-data-text="No hay registros..."
              hide-details
              dense
              v-model="filters.status"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-select
              outlined
              :items="charges"
              item-text="name"
              item-value="id"
              label="Seleccione Cargo"
              no-data-text="No hay registros..."
              hide-details
              dense
              v-model="filters.charge"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-btn block color="secondary" @click="searchFilters">
              Buscar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Table -->
    <v-card>
      <v-data-table
        :headers="headers"
        :items="this.$store.state.contract.contracts.contracts.data"
        :search="search"
        hide-default-footer
        :items-per-page="20"
        :loading="this.$store.state.contract.contracts.isLoading"
        loading-text="Cargando... Por favor espere"
        no-data-text="No hay registro"
        no-results-text="Lo sentimos no hay registro para su busqueda, intente con otro"
      >
        <template v-slot:[`item.reference`]="item">
          <v-chip color="primary" small>
            {{ item.item.reference }}
          </v-chip>
        </template>
        <template v-slot:[`item.employee`]="item">
          {{ item.item.employee.user.full_name }}
        </template>
        <template v-slot:[`item.charge`]="item">
          {{ item.item.employee.charge.name }}
        </template>
        <template v-slot:[`item.status`]="item">
          <v-chip :color="getContractStatuColor(item.item.status)" dark small>
            {{ getContractStatus(item.item.status) }}
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="item">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="show(item.item.id)"
              >
                mdi-eye-outline
              </v-icon>
            </template>
            <span>Ver</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="green"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="openContract(item.item)"
              >
                mdi-file-download
              </v-icon>
            </template>
            <span>Descargar Contrato</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="red"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="upload(item.item)"
                target="_blank"
                v-if="role == 'EMPLOYEE' && !item.item.contract_signed_url"
              >
                mdi-file-upload
              </v-icon>
            </template>
            <span>Subir Contrato Firmado</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="blue"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="createReport(item.item.id)"
                v-if="
                  item.item.reports_count < item.item.reports &&
                  role == 'EMPLOYEE' &&
                  item.item.status == 'ACTIVE' &&
                  item.item.employee.charge.can_create_report
                "
              >
                mdi-text-box-plus
              </v-icon>
            </template>
            <span>Crear Informe</span>
          </v-tooltip>
          <v-tooltip
            bottom
            v-if="
              item.item.status !== 'INACTIVE' &&
              item.item.status !== 'COMPLETED' && 
              role == 'ADMINISTRATOR'
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="red"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="changeStatus('INACTIVE', item.item)"
              >
                mdi-file-cancel
              </v-icon>
            </template>
            <span>Inactivar</span>
          </v-tooltip>
          <v-tooltip
            bottom
            v-if="
              item.item.status !== 'INACTIVE' &&
              item.item.status !== 'COMPLETED' && 
              role == 'ADMINISTRATOR'
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="green"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="changeStatus('COMPLETED', item.item)"
              >
                mdi-text-box-check
              </v-icon>
            </template>
            <span>Finalizar</span>
          </v-tooltip>
          <v-tooltip bottom v-if="role == 'ADMINISTRATOR'">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="red"
                dark
                v-bind="attrs"
                v-on="on"
                @click="distroy(item.item)"
                class="px-1"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>        
      </v-data-table>

      <v-col cols="12" sm="12" md="12">
        <v-pagination
          v-model="pagination.current"
          :length="pagination.total"
          :total-visible="8"
          circle
          @input="nextPage"
        ></v-pagination>
      </v-col>
    </v-card>

    <!-- Button active dialog / create record-->
    <v-btn
      class="mx-2"
      fab
      dark
      bottom
      fixed
      right
      color="secondary"
      href="/contracts/create"
      v-if="role == 'ADMINISTRATOR'"
    >
      <v-icon dark> mdi-plus </v-icon>
    </v-btn>

    <!-- Dialog upload contract signed -->
    <v-dialog v-model="dialogUpload" width="500" persistent>
      <v-card>
        <v-card-title v-if="currentContract">
          Subir Contrato Firmado - #{{ currentContract.reference }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="formUploadContract" v-model="formUploadContract">
            <v-file-input
              accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
              label="Contrato Firmado"
              v-model="model.contract_signed_file"
            ></v-file-input>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="cancelUpload">Cancelar</v-btn>
          <v-btn text color="primary" @click="saveUpload">Subir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog change status -->
    <v-dialog v-model="dialogChangeStatus" width="500" persistent>
      <v-card>
        <v-card-title v-if="currentContract && statusText != ''" class="d-block">
          <p class="text-center">
            Seguro que desea cambiar a {{ getContractStatus(statusText) }}
            <br />
            el contrato - #{{ currentContract.reference }}
          </p>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="cancelCangeStatus">Cancelar</v-btn>
          <v-btn text color="primary" @click="changeStatusConfirmation"
            >Aceptar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- delete dialog -->
    <v-dialog v-model="dialogDelete" width="500" persistent>
      <v-card>
        <v-card-text class="py-4">
          Seguro que desea eliminar este contrato?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            class="mr-4"
            @click="distroyConfirmation"
            small
          >
            Confirmar
          </v-btn>

          <v-btn color="error" text class="mr-4" @click="closeDistroy" small>
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_ALERT } from "@/store/alert";
import { SET_CONTRACTS } from "@/store/contract/contracts";
import { SET_CHARGES } from "@/store/charge/charges";
import { SET_INFO } from "@/store/areas";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
export default {
  name: "Contracts",
  components: {
    VueCtkDateTimePicker,
  },
  filters: {
    formatNumber(value) {
      return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
      }).format(value);
    },
  },
  data: () => ({
    search: "",
    info: [],
    dialogUpload: false,
    dialogDelete: false,
    formUploadContract: true,
    dialogChangeStatus: false,
    showFilters: false,
    searchInput: "",
    statusText: "",
    headers: [
      {
        text: "# Contrato",
        value: "reference",
        filterable: true,
        sortable: true,
      },
      {
        text: "Colaborador",
        value: "employee",
        filterable: true,
        sortable: true,
      },
      { text: "Cargo", value: "charge", filterable: true, sortable: true },
      {
        text: "Fecha Inicio",
        value: "start_date",
        filterable: true,
        sortable: true,
      },
      {
        text: "Fecha Finalización",
        value: "end_date",
        filterable: true,
        sortable: true,
      },
       {
        text: "Area",
        value: "area.nombre",

        sortable: true,
      },
      { text: "Estado", value: "status", filterable: true, sortable: false },
      { text: "Acciones", value: "actions", filterable: true, sortable: false },
    ],
    filters: {
      status: "",
      charge: "",
    },
    pagination: {
      current: 0,
      total: 0,
    },
    model: {
      contract_signed_file: [],
    },
    charges: [],
    currentContract: null,
  }),
  created() {
    this.$store.dispatch("getAreaInfo");


      this.$store.subscribe((mutation) => {
      if (mutation.type === SET_INFO) {
      this.info = this.$store.state.areas.info;
      this.$store.state.contract.contracts.area = this.info.config.id;
      

      
      this.$store.dispatch("getContracts");
      this.$store.dispatch("getChargesAll");
    
        this.$store.subscribe((mutation, state) => {
	if (mutation.type === SET_CONTRACTS) {

        this.pagination.current =
          state.contract.contracts.contracts.current_page;
        this.pagination.total = state.contract.contracts.contracts.last_page;
      }
      if (mutation.type === SET_CHARGES) {
        this.charges = state.charge.charges.charges;
      }
    });
    
      }
      
      });
            

  },
  computed: {
    ...mapGetters(["getContractStatus", "getContractStatuColor"]),
    role() {
      return this.$store.state.user.user != null
        ? this.$store.state.user.user.role
        : "";
    },
    datePiker() {
      return this.$store.state.status.datePiker;
    },
  },
  methods: {
    show(id) {
      window.open(`/contracts/show/${id}`, '_blank').focus();      
    },
    generateCsv() {
    console.log("Genera un svg");
     this.$store.dispatch("downloadContractsExcel");
     
    },
    openContract(contract) {
      window.open(contract.contract_url, "_blank");
    },
    nextPage() {
      this.$store.dispatch("nextPageContracts", this.pagination.current);
    },
    upload(contract) {
      this.currentContract = contract;
      this.dialogUpload = true;
    },
    createReport(id) {
      this.$router.push({ path: `/contracts/${id}/reports/create` });
    },
    cancelUpload() {
      this.currentContract = null;
      this.dialogUpload = false;
    },
    saveUpload() {
      if (this.model.contract_signed_file.length == 0) {
        this.$store.commit(SET_ALERT, {
          message: "Debe seleccionar un archivo",
          type: "error",
        });
        return;
      }

      this.model._method = "put";
      this.$store.dispatch("updateContract", {
        id: this.currentContract.id,
        form: this.createFormData(),
      });
      this.cancelUpload();
    },
    createFormData() {
      let formData = new FormData();
      Object.entries(this.model).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((element, index) => {
            formData.append(key + "[" + index + "]", element);
          });
        } else {
          formData.append(key, value);
        }
      });
      return formData;
    },
    searchText() {
      if (this.searchLoanInput == "") {
        this.$store.commit(SET_ALERT, {
          message: "Ingrese un valor de busqueda",
          type: "info",
        });
        return;
      }
      this.showFilters = false;
      this.$store.dispatch("getContracts", "search=" + this.searchInput + "&");
    },
    searchFilters() {
      this.searchFiltersText = "";

      if (this.datePiker.model !== null) {
        this.searchFiltersText =
          "min_date=" +
          this.datePiker.model.start +
          "&max_date=" +
          this.datePiker.model.end +
          "&";
      }

      if (this.filters.charge !== "") {
        this.searchFiltersText += "charge=" + this.filters.charge + "&";
      }

      if (this.filters.status !== "") {
        this.searchFiltersText += "status=" + this.filters.status + "&";
      }

      if (this.searchFiltersText == "") {
        this.$store.commit(SET_ALERT, {
          message: "Ingrese un valor de busqueda",
          type: "info",
        });
        return;
      }

      this.showFilters = false;
      this.$store.dispatch("getContracts", this.searchFiltersText);
    },
    reload() {
      this.searchInput = "";
      this.filters = {
        status: "",
        charge: "",
      };
      this.datePiker.model = null;
      this.searchFiltersText = "";
      this.showFilters = false;
      this.$store.dispatch("getContracts");
    },
    changeStatus(status, contract) {
      this.currentContract = contract;
      this.statusText = status;
      this.dialogChangeStatus = true;
    },
    cancelCangeStatus() {
      this.currentContract = null;
      this.statusText = "";
      this.dialogChangeStatus = false;
    },
    changeStatusConfirmation() {
      this.$store.dispatch("updateContract", {
        id: this.currentContract.id,
        form: {
          status: this.statusText,
          _method: "put",
        },
      });
      this.cancelCangeStatus();
    },
    distroy(contract) {
      this.currentContract = contract;
      this.dialogDelete = true;
    },
    distroyConfirmation() {
      this.$store.dispatch("deleteContract", this.currentContract.id);
      this.closeDistroy();
    },
    closeDistroy() {
      this.currentContract = null;
      this.dialogDelete = false;
    },
  },
};
</script>
<style scoped>
.user {
  height: 100%;
}
.v-btn--bottom {
  bottom: 11px !important;
}
</style>
